declare var process: any

export const Env = {
  appVersion: process.env["REACT_APP_VERSION"],
  apiSecurityCode: process.env["REACT_APP_API_SECURITY_CODE"],
  apiUrl: process.env["REACT_APP_API_URL"],
  webUrl: process.env["REACT_APP_WEB_URL"],
  googleClientKey: process.env["REACT_APP_GOOGLE_CLIENT_KEY"]
}
